import React from 'react';

import { ListItem, Button } from '@mui/material';
import { useTrackUserEvent } from '../../hooks/api/useTrackUserEvent';
import { useAuthContext } from '../../contexts/AuthContext';
import { navigationButtonStyles } from './sidebarStyles';

type SidebarNavActionItemProps = {
  depth: number;
  onAction: () => void;
  icon?: React.ComponentType;
  title: string;
  eventCode?: string;
};

const SidebarNavActionItem: React.FC<SidebarNavActionItemProps> = ({
  title,
  onAction,
  icon: Icon,
  eventCode,
}) => {
  const { account } = useAuthContext();
  const { mutate: trackUserEvent } = useTrackUserEvent();

  return (
    <ListItem disablePadding>
      <Button
        variant="navigation"
        onClick={() => {
          if (eventCode) {
            trackUserEvent({
              slug: account,
              eventCode: 'c',
              payload: { on: eventCode },
            });
          }
          onAction();
        }}
        startIcon={Icon ? <Icon /> : null}
        sx={navigationButtonStyles}
      >
        {title}
      </Button>
    </ListItem>
  );
};

export default SidebarNavActionItem;
